//export const api="http://172.21.4.15:8082"
//export const api="http://0.0.0.0:8082"
export const api="https://api-ih.atentus.com"
export const key="bg52dfsd2311fsd54sfd3241fsd35"
export const listSaved=[{"name":"NSV login prepago", "id":59994}, {"name":"APP Login Prepago", "id":62166},{"name":"APP Login Pospago","id":62165},{"name":"NSV login pospago", "id":60218}]


// WEBPACK FOOTER //
// ./src/common/globals.js